/*eslint-disable*/
import React, { useState, useEffect } from "react";

import APIClient from "../client";
import config from "../config.js";
import TableChart from "../components/Charts/TableChart.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";


const client = new APIClient(config);


export default function AdminFileLog() {
    const [data, setData] = useState(null);
    const [columnData, setColumnData] = useState(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchImportLog();
    }, []);

    const fetchImportLog = () => {
        client.getIngestionLog().then((data) => {
            setData(data['data']['data']);
            const columns = [
                {
                    name: "fileContent",
                    selector: (row) => row.fileContent,
                },
                {
                    name: "fileFormat",
                    selector: (row) => row.fileFormat,
                },
                {
                    name: "fileDelimiter",
                    omit: true,
                    selector: (row) => row.fileDelimiter,
                },
                {
                    name: "s3Bucket",
                    selector: (row) => row.s3Bucket,
                },

                {
                    name: "s3Key",
                    selector: (row) => row.s3Bucket,
                },
                {
                    name: "id",
                    omit: true,
                    selector: (row) => row.id,
                },
                {
                    name: "loadStatus",
                    width: "100px",
                    selector: (row) => row.loadStatus,
                },
                {
                    name: "logCreatedAt",
                    sortable: true,
                    width: "200px",
                    selector: (row) => row.logCreatedAt,
                },
                {
                    name: "logUpdatedAt",
                    width: "200px",
                    selector: (row) => row.logUpdatedAt,
                },
            ];

            setColumnData(columns);
            setLoading(false);
            setError(null);
        });
    };

    const ExpandedComponent = ({ data }) => <pre>{JSON.stringify(data, null, 2)}</pre>;
    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "Ingestion Log";

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    {loading && (
                        <div className="text-xl font-medium">Loading...</div>
                    )}
                    {error && <CardError message={error} />}

                    {data && (

                        <>
                            <h2 className="text-36 text-yellow mb-6">File Ingestion Log</h2>

                            <TableChart
                                columns={columnData}
                                data={data}
                                expandableRows
                                expandableRowsComponent={ExpandedComponent}
                                defaultSortFieldId={6}
                                dense
                            />

                        </>


                    )}

                </div>

            </section>

        </>
    );
}

